// Web stub for @invertase/react-native-apple-authentication
import React from 'react';

export const AppleButton = React.forwardRef<HTMLButtonElement>((props: any, ref) => {
  const { onPress, buttonStyle, style } = props;

  return (
    <button
      ref={ref}
      onClick={onPress}
      style={{
        padding: '10px 20px',
        fontSize: '16px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: '#000',
        color: '#fff',
        cursor: 'pointer',
        ...style,
      }}
    >
      Sign in with Apple
    </button>
  );
});

AppleButton.displayName = 'AppleButton';

export default {
  AppleButton,
};
